import { z } from 'zod';

export const KdsStatus = z.enum(['NEW', 'COOKING', 'READY', 'SERVED']);
export type KdsStatus = z.infer<typeof KdsStatus>;

export const KdsTicket = z.object({
  orderId: z.string(),
  number: z.number().int(),
  mode: z.enum(['DINE_IN', 'TAKEAWAY', 'DELIVERY']),
  status: KdsStatus,
  closedAt: z.string().datetime(),   // момент оплаты = постановка в очередь
  table: z.string().nullable(),
  items: z.array(z.object({ name: z.string(), qty: z.number(), mods: z.array(z.string()),
    /** цех позиции: kitchen | bar | null */
    station: z.string().nullable().optional(),
    /** курс подачи: кухня группирует позиции волнами */
    course: z.number().int().nullable().optional() })),
});
export type KdsTicket = z.infer<typeof KdsTicket>;

export const KdsQueue = z.object({
  tickets: z.array(KdsTicket),
  /** для магазина/салона кухня выключена — экран честно об этом скажет */
  kitchen: z.boolean(),
  /** замок подписки: не оплатили — экран кухни закрыт */
  lock: z.object({
    kind: z.enum(['WARN', 'BLOCK']),
    blocked: z.boolean(),
    message: z.string(),
    days: z.number().int(),
    paidUntil: z.string().nullable(),
  }).optional(),
});
export type KdsQueue = z.infer<typeof KdsQueue>;

export const KdsStatusPatch = z.object({ status: KdsStatus });
export type KdsStatusPatch = z.infer<typeof KdsStatusPatch>;
